import React from 'react';
import SVG from './SVG';
const NavIconExample = ({ className }) => (React.createElement(SVG, { width: '24', height: '24', viewBox: "0 0 20 20", className: className },
    React.createElement("path", { fill: 'currentColor', d: "M4.5,15.611h8.889V4.5H4.5Zm0,8.889h8.889V17.833H4.5Zm11.111,0H24.5V13.389H15.611Zm0-20v6.667H24.5V4.5Z", transform: "translate(-4.5 -4.5)" })));
export default NavIconExample;
//# sourceMappingURL=NavIconExample.js.map